@if (message) {
  <div class="fixed-top d-flex justify-content-center mt-3" style="z-index: 1050; pointer-events: none;">
    <div class="alert alert-dismissible fade show shadow-sm d-flex align-items-center" role="alert" [ngClass]="alertClass" style="pointer-events: auto; max-width: 90%; width: auto; min-width: 300px;">
      <i [class]="iconClass" class="flex-shrink-0 me-2 fs-4"></i>
      <div class="flex-grow-1 me-3">
        {{ message }}
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
  </div>
}
